import { TimeRange } from "@/types/time-range";
import { PREFIX_STATS_LIFETIME } from "@/config/series";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class GetPrefixStats extends Vue {
  intervalID = 0;

  // Use in created()
  getPrefixStats(prefixID: number, timeRange?: TimeRange) {
    const action: () => void = () => {
      if (timeRange) {
        this.$store.dispatch("debugMode/fetchPrefixStats", { timeRange, prefixID });
      } else {
        this.$store.dispatch("debugMode/fetchPrefixStatsByTimeRange", prefixID);
      }
    };

    action();

    // Refetch data periodically
    this.intervalID = setInterval(() => {
      action();
    }, PREFIX_STATS_LIFETIME);
  }

  // Use in beforeDestroy()
  cleanUpPrefixStats() {
    clearInterval(this.intervalID);
  }
}
